<template>
    <div class="com-mid-content text-white">
        <div class="" v-if="dataShow">
            <div style="padding:0 15px;box-sizing: border-box">
                <div class="flex align-center flex-wrap text-center text-white text-bold justify-between">
                    <div class="leftNumItem2">
                        <div class="">
                            <div class="base-font-16">今日收货量(kg)</div>
                            <div class="base-font-26 bold text-color-blue">{{item.dayWeight?item.dayWeight:'0'}}</div>
                        </div>
                    </div>
                    <div class="leftNumItem2">
                        <div class="">
                            <div class="base-font-16">本月收货量(kg)</div>
                            <div class="base-font-26 bold text-color-green">{{item.monthWeight?item.monthWeight:'0'}}</div>
                        </div>
                    </div>
                    <div class="leftNumItem3">
                        <div class="circleContent">
                            <div class="xzBg"></div>
                            <div class="content">
                                <div class="flex align-center justify-center text-center" style="height:180px;">
                                    <div>
                                        <div class="base-font-18">总收货量(kg)</div>
                                        <div class="base-font-32 bold text-color-yellow margin-top-10">
                                            {{item.allWeight?item.allWeight:"0"}}</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="leftNumItem2">
                        <div class="">
                            <div class="base-font-16">总付款金额(万元)</div>
                            <div class="base-font-26 bold " style="color: #00ff97;">{{item.allMoney?item.allMoney:'0'}}</div>
                        </div>
                    </div>
                    <div class="leftNumItem2">
                        <div class="">
                            <div class="base-font-16">总库存量(kg)</div>
                            <div class="base-font-26 bold text-color-red">{{item.stockWeight?item.stockWeight:'0'}}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="margin-top-20 padding-top-10">
            <div class="flex align-center justify-around">
                <div>
                    <div class="midCircle">
                        <div class="midInfo text-center">
                            <div class="text-bold text-color-blue" style="font-size:24px;">
                                {{ item.sites && item.sites.length>0? item.sites.length:'0'}}
                            </div>
                            <div class="base-font-14 margin-top-5 ">站点数(个)</div>
                        </div>
                        <el-image style="width: 130px; height: 130px" class="roteCircle" :src="circleImage"
                            fit="fill"></el-image>
                    </div>
                </div>
                <div>
                    <div class="midCircle">
                        <div class="midInfo text-center">
                            <div class="text-bold text-color-green" style="font-size:24px;">
                                {{ item.dayMoney?item.dayMoney:"0" }}
                            </div>
                            <div class="base-font-14 margin-top-5 ">今日付款金额(万元)</div>
                        </div>
                        <el-image style="width: 130px; height: 130px" class="roteCircle" :src="circleImage"
                            fit="fill"></el-image>
                    </div>
                </div>

                <div>
                    <div class="midCircle">
                        <div class="midInfo text-center">
                            <div class="text-bold text-color-orange" style="font-size:24px;">
                                {{ item.monthMoney?item.monthMoney:'0' }}
                            </div>
                            <div class="base-font-14 margin-top-5 ">本月付款金额(万元)</div>
                        </div>
                        <el-image style="width: 130px; height: 130px" class="roteCircle" :src="circleImage"
                            fit="fill"></el-image>
                    </div>
                </div>

                <div>
                    <div class="midCircle">
                        <div class="midInfo text-center">
                            <div class="text-bold text-color-yellow" style="font-size:24px;">{{ item.allMoney }}</div>
                            <div class="base-font-14 margin-top-5 ">今日出库重量(kg)</div>
                        </div>
                        <el-image style="width: 130px; height: 130px" class="roteCircle" :src="circleImage"
                            fit="fill"></el-image>
                    </div>
                </div>
                <div>
                    <div class="midCircle">
                        <div class="midInfo text-center">
                            <div class="text-bold text-color-yellow" style="font-size:24px;">{{ item.allMoney }}</div>
                            <div class="base-font-14 margin-top-5 ">本月出库量(kg)</div>
                        </div>
                        <el-image style="width: 130px; height: 130px" class="roteCircle" :src="circleImage"
                            fit="fill"></el-image>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "cityGreenLand",
        data() {
            return {
                item: {
                    dayWeight:0
                },
                timerMid: null,
                dataShow:false,
                circleImage: require("../../../assets/images/xsd/circle.png")
            }
        },
        mounted() {
            
        },

        methods: {
            getData(data) {
                this.dataShow=true
                this.$nextTick(()=>{
                    this.item = data
                })
                
                this.$forceUpdate()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .margin-top-5{margin-top:8px;}
    .base-font-32 {
        font-size: 32px;
    }
    .base-font-26 {
        font-size: 26px;
    }

    .com-mid-content {
        min-height: 500px;
        padding: 40px 5px 15px 5px;
        box-sizing: border-box;

        & .midItemBox {
            width: 15vw;
            box-sizing: border-box;
            height: 110px;
            line-height: 0.6;

            & .zdInfo {
                font-size: 36px;
                padding-top: 20px;

                & .num {
                    font-size: 36px;
                    font-weight: bold;
                }

                & .item {
                    align-items: flex-end;
                }
            }
        }

        .midItemBox.jb1 {
            padding: 27px 0 0 30px;
            background: -webkit-linear-gradient(left, rgba(6, 32, 74, 1), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 0.2), rgba(6, 32, 74, 0));
            /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(right, rgba(6, 32, 74, 1), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 0.2), rgba(6, 32, 74, 0));
            /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(right, rgba(6, 32, 74, 1), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 0.2), rgba(6, 32, 74, 0));
            /* Firefox 3.6 - 15 */
            background: linear-gradient(to right, rgba(6, 32, 74, 1), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 0.2), rgba(6, 32, 74, 0));
        }

        .midItemBox.jb2 {
            padding: 27px 30px 0 0;
            background: -webkit-linear-gradient(left, rgba(6, 32, 74, 0), rgba(6, 32, 74, 0.3), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 1));
            /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(right, rgba(6, 32, 74, 0), rgba(6, 32, 74, 0.3), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 1));
            /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(right, rgba(6, 32, 74, 0), rgba(6, 32, 74, 0.3), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 1));
            /* Firefox 3.6 - 15 */
            background: linear-gradient(to right, rgba(6, 32, 74, 0), rgba(6, 32, 74, 0.3), rgba(6, 32, 74, 0.5), rgba(6, 32, 74, 1));
        }

        .midCircle {
            width: 130px;
            height: 130px;
            border-radius: 50%;
            position: relative;
            box-shadow: 0 0 40px rgba(21, 88, 152, 0.2);
            background: -webkit-linear-gradient(top, rgba(0, 35, 82, 1), rgba(9, 20, 45, 1));
            /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(bottom, rgba(0, 35, 82, 1), rgba(9, 20, 45, 1));
            /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(bottom, rgba(0, 35, 82, 1), rgba(9, 20, 45, 1));
            /* Firefox 3.6 - 15 */
            background: linear-gradient(to bottom, rgba(0, 35, 82, 1), rgba(9, 20, 45, 1));

            .midInfo {
                width: 130px;
                height: 130px;
                position: absolute;
                top: 0;
                left: 0;
                padding-top: 38px;
                box-sizing: border-box;
                line-height: 1.1;
            }
        }

        .roteCircle {
            animation: rotateCircle 9s infinite linear;
            -webkit-animation: rotateCircle 9s infinite linear;
            /* Safari 与 Chrome */
        }


    }

    //调整******
    .leftNumItem2 {
        padding-top: 30px;
        width: 18%;
        height: 115px;
        background: url("../../../assets/img/dataK.png") center no-repeat;
        background-size: 100% 100%;
        line-height: 1.5;
        box-sizing: border-box;

        .text-color-red {
            color: #ff94a3;
        }


    }

    .leftNumItem3 {
        width: 180px;
        height: 180px;
        background: none;
        padding-top: 0;

        .circleContent {
            width: 180px;
            height: 180px;
            text-align: center;
            position: relative;

            .xzBg {
                width: 220px;
                height: 220px;
                position: absolute;
                left: -20px;
                top: -20px;
                background: url("../../../assets/img/circleXz.png") center no-repeat;
                background-size: 100% 100%;
                animation: rotateCircle 9s infinite linear;
                -webkit-animation: rotateCircle 9s infinite linear;
            }

            .content {
                width: 180px;
                height: 180px;
                position: absolute;
                left: 0;
                top: 0;
                border-radius: 50%;
                line-height: 1.2;
                background: -webkit-linear-gradient(top, rgba(0, 174, 255, 0.8), rgba(2, 20, 48, 0.8));
                /* Safari 5.1 - 6.0 */
                background: -o-linear-gradient(bottom, rgba(0, 174, 255, 0.8), rgba(2, 20, 48, 0.8));
                /* Opera 11.1 - 12.0 */
                background: -moz-linear-gradient(bottom, rgba(0, 174, 255, 0.8), rgba(2, 20, 48, 0.8));
                /* Firefox 3.6 - 15 */
                background: linear-gradient(to bottom, rgba(0, 174, 255, 0.8), rgba(2, 20, 48, 0.8));
            }

        }
    }
</style>